import React, { ChangeEvent, Component, useContext, useEffect, useState } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetCatalogItemDTO from "../../../models/DTO/IGetCatalogItemDTO";
import IOnTypeaheadCatalogItemDTO from "../../../models/DTO/IOnTypeaheadCatalogItemDTO";
import IProcessVendorSourceCatalogItemDTO from "../../../models/DTO/IProcessVendorSourceCatalogItemDTO";
import ITypeaheadCatalogItemDTO from "../../../models/DTO/ITypeaheadCatalogItemDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICatalog from "../../../models/ICatalog";
import ICatalog_Item from "../../../models/ICatalog_Item";
import INotification from "../../../models/INotification";
import IOwTableCols from "../../../models/IOwTableCols";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendor_Source from "../../../models/IVendor_Source";
import OwButton from "../../shared/OwButton/OwButton";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import Typeahead from "../../shared/Typeahead/Typeahead";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import { NumericFormat } from "react-number-format";
import { Socket } from "socket.io-client";
import IPrice_Band_Compiled from "../../../models/IPrice_Band_Compiled";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";
import { SocketContext } from "../../../contexts/SocketContext";
import { VendorSourceCatalogItemSidebar } from "../VendorSourceCatalogItemSidebar/VendorSourceCatalogItemSidebar";
import UiContext from "../../../contexts/UiContext";
import IOnProcessVendorSourceCatalogItemDTO from "../../../models/DTO/IOnProcessVendorSourceCatalogItemDTO";
import HelperService from "../../../services/HelperService";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import OwPill from "../../shared/OwPill/OwPill";
import { PriceBandPriceDisplay } from "../../shared/PriceBandPriceDisplay/PriceBandPriceDisplay";
import {OwDeleteEditActions} from "../../shared/OwDeleteEditActions/OwDeleteEditActions";

type Props = {
    catalogs: ICatalog[];
    vendorSource: IVendor_Source;
    parentRowIndex: number;
};

export const VendorSourceCatalogItemsDetailView = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const toggleConfirmDelete = (row: ICatalog_Item, index: number) => {
        setTargetDeleteElem(`row-${props.parentRowIndex}-${index}`);
        setDeleteRow(row);
    };

    const renderActionsCol = (row: ICatalog_Item, index: number) => {
        return (
            <div>
                <OwDeleteEditActions
                    isEditMode={false}
                    onTrashClickFn={() => {
                        toggleConfirmDelete(row, index);
                    }}
                    onEditClickFn={() => {
                        openVendorSourceCatalogItemSidebar(row);
                    }}
                />
            </div>
        );
    };

    const renderMpn = (row: ICatalog_Item) => {
        if (row.Catalog_Item_Vendor_Source_Map) {
            return row.Catalog_Item_Vendor_Source_Map.manuf_part_no;
        }
    };

    const renderCostPrice = (row: ICatalog_Item) => {
        if (row.Catalog_Item_Vendor_Source_Map) {
            let priceBands: IPrice_Band_Compiled[] | undefined;

            if (row.has_price_bands && row.Price_Bands) {
                priceBands = row.Price_Bands[`${props.vendorSource.name}_cost`] || [];
            }

            if (priceBands) {
                return <PriceBandPriceDisplay bands={priceBands} />;
            } else {
                if (row.Catalog_Item_Vendor_Source_Map.cost_price) {
                    return HelperService.formatCurrency({
                        value: row.Catalog_Item_Vendor_Source_Map.cost_price,
                        currency: "USD",
                        precision: supplierModel.pricing_precision,
                    });
                }
            }
        }
    };

    const renderNameCol = (row: ICatalog_Item) => {
        return (
            <div>
                {row.name}
                {row.default_vendor_source_id === props.vendorSource.id ? <OwPill className={"ms-2"} title={"default"} /> : ""}
            </div>
        );
    };

    const getTableCols = (): IOwTableCols[] => {
        return [
            {
                isActionsCol: true,
                renderFn: renderActionsCol,
                renderFnEmitsRow: true,
                title: "",
                valueProp: "",
            },
            {
                title: "catalog",
                valueProp: "Catalog",
                valueSubProp: "name",
            },
            {
                title: "name",
                valueProp: "name",
                renderFnEmitsRow: true,
                renderFn: renderNameCol,
            },
            {
                title: "sku",
                valueProp: "sku",
            },
            {
                title: "mpn",
                valueProp: "manuf_part_no",
                renderFnEmitsRow: true,
                renderFn: renderMpn,
            },
            {
                title: "cost_price",
                valueProp: "Catalog_Item_Vendor_Source_Map",
                valueSubProp: "cost_price",
                renderFn: renderCostPrice,
                renderFnEmitsRow: true,
            },
        ];
    };

    const [deleteRow, setDeleteRow] = useState<ICatalog_Item | undefined>();
    const [targetDeleteElem, setTargetDeleteElem] = useState<string | null>(null);
    const [vendorSource, setVendorSource] = useState<IVendor_Source>(props.vendorSource);
    const [selectedCatalogGuid, setSelectedCatalogGuid] = useState<string | undefined>();
    const [costPrice, setCostPrice] = useState(0);
    const [mpn, setMpn] = useState("");
    const [columns, setColumns] = useState<IOwTableCols[]>(getTableCols());
    const [typeaheadItems, setTypeaheadItems] = useState<ICatalog_Item[]>([]);
    const [selectedTypeaheadItem, setSelectedTypeaheadItem] = useState<ICatalog_Item | undefined>();
    const [clearTypeahead, setClearTypeahead] = useState(false);

    const onTypeaheadCatalogItem = (data: IOnTypeaheadCatalogItemDTO) => {
        setTypeaheadItems(data.catalog_items);
    };

    const onProcessVendorSourceCatalogItem = (data: IOnProcessVendorSourceCatalogItemDTO) => {
        if (data.vendorSource.guid === props.vendorSource.guid) {
            setVendorSource(data.vendorSource);
        }
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.CatalogItemOnTypeaheadCatalogItem, fn: onTypeaheadCatalogItem },
        { endpoint: EndpointsEnum.PurchaseOrderOnProcessVendorSourceCatalogItem, fn: onProcessVendorSourceCatalogItem },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const closeSidebar = (refresh?: boolean) => {
        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);
    };

    const openVendorSourceCatalogItemSidebar = (row: ICatalog_Item) => {
        const component = <VendorSourceCatalogItemSidebar closeFn={closeSidebar} catalogItem={row} vendorSource={props.vendorSource} />;
        uiContext.setSidebarComponent(component);
        uiContext.toggleSidebar(true);
    };

    const removeCatalogItem = (item: ICatalog_Item) => {
        const payload: IProcessVendorSourceCatalogItemDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorSourceGuid: props.vendorSource.guid,
            catalogItems: [{ guid: item.guid, costPrice: 0, manuf_part_no: "", deleteFlag: true }],
        };

        socket.emit(EndpointsEnum.PurchaseOrderProcessVendorSourceCatalogItem, payload);
    };

    const toggleEditMode = (row: ICatalog_Item) => {};

    const typeaheadCatalogItem = (name: string) => {
        if (selectedCatalogGuid) {
            const payload: ITypeaheadCatalogItemDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                catalogGuid: selectedCatalogGuid,
                name,
                options: {
                    searchName: true,
                    searchDescription: true,
                    searchSku: true,
                    searchUpc: true,
                },
            };

            socket.emit(EndpointsEnum.CatalogItemTypeaheadCatalogItem, payload);
        }
    };

    const selectTypeaheadItem = (item: ICatalog_Item) => {
        setSelectedTypeaheadItem(item);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        switch (name) {
            case "cost_price":
                setCostPrice(value);
                break;
            case "mpn":
                setMpn(value);
                break;
            case "selectedCatalogGuid":
                setSelectedCatalogGuid(value);
                break;
        }
    };

    const addCatalogItem = () => {
        if (selectedTypeaheadItem) {
            const payload: IProcessVendorSourceCatalogItemDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                vendorSourceGuid: props.vendorSource.guid,
                catalogItems: [
                    {
                        guid: selectedTypeaheadItem.guid,
                        costPrice,
                        manuf_part_no: mpn,
                    },
                ],
            };

            socket.emit(EndpointsEnum.PurchaseOrderProcessVendorSourceCatalogItem, payload);

            setSelectedTypeaheadItem(undefined);
            setClearTypeahead(true);
            setCostPrice(0);
            setMpn("");
            setTypeaheadItems([]);
        }
    };

    const cancelDelete = () => {
        setTargetDeleteElem(null);
        setDeleteRow(undefined);
    };

    return (
        <div className={"VendorSourceCatalogItemsDetailView"}>
            <div className="d-flex flex-column">
                <div>
                    <OwTitle title={"catalog_items"} tag={"h5"} />
                </div>
                <div className={"d-flex mb-2"}>
                    <div>
                        <OwLabel title={"catalog"} />
                        <OwSelectOption
                            fn={handleChange}
                            options={props.catalogs}
                            titleProp={"name"}
                            valueProp={"guid"}
                            name={"selectedCatalogGuid"}
                            selectedOption={"selectedCatalogGuid"}
                            hasSelectedOptionProp={false}
                            className={"me-2"}
                        />
                    </div>
                    <div>
                        <OwLabel title={"item"} />
                        <Typeahead
                            isSelectableFn={() => {
                                return true;
                            }}
                            typeaheadApiFn={typeaheadCatalogItem}
                            typeaheadItems={typeaheadItems}
                            titleProp={"name"}
                            subTitleProp={"sku"}
                            selectedItemFn={selectTypeaheadItem}
                            selectedItem={selectedTypeaheadItem}
                            selectedItemTitleProp={"name"}
                            scrollableList={true}
                        />
                    </div>
                    <div className="ms-2">
                        <OwLabel title={"cost_price"} />
                        <OwFnInput fn={handleChange} name={"cost_price"} value={costPrice} />
                    </div>
                    <div className="ms-2">
                        <OwLabel title={"manuf_part_no"} />
                        <OwFnInput fn={handleChange} name={"mpn"} value={mpn} />
                    </div>
                    <div className={"ms-2"}>
                        <OwLabel title={""} />
                        <div>
                            <OwButton title={"add"} fn={addCatalogItem} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="row position-relative">
                <div className="col-12">
                    <ConfirmDeleteOverlayFn
                        handleConfirm={() => {
                            removeCatalogItem(deleteRow!);
                        }}
                        handleCancel={cancelDelete}
                        targetElem={targetDeleteElem}
                        message={"confirm_delete"}
                        leftAdjustment={-12}
                        skipMainView={true}
                        nestedParentElem={`vendor-source-items-table-${props.vendorSource.guid}`}
                    />

                    <div>
                        <OwTable
                            id={`vendor-source-items-table-${props.vendorSource.guid}`}
                            columns={columns}
                            dataSet={vendorSource.Catalog_Items || []}
                            userModel={userModel}
                            supplierModel={supplierModel}
                            dataFetch={false}
                            initialData={false}
                            parentRowIndex={props.parentRowIndex}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
